import React, { useCallback, useRef, useState } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Button } from 'react95-native-rabbl';
import { AppText } from '@/components/AppText';
import Head from 'expo-router/head';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import { Link } from 'expo-router';
import Footer from '@/components/Footer';
import { Video, IVideo } from '@/components/Video';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import { useFocusEffect, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 20,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
});

export default function Loggedout() {
  const router = useRouter();
  const video = useRef<IVideo>(null);
  const isMainLogicalHost = useSelector((state: RootState) => state.user.isMainLogicalHost);
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const communityMembership = useSelector((state: RootState) => state.user.communityMembership);

  useFocusEffect(
    useCallback(() => {
      return () => {
        video.current?.pause();
      };
    }, [])
  );

  return (
    <BasicScrollView center={true}>
      <Meta title={"Logged out"} />
      <View style={styles.container}>
        <AppText>See ya next time.</AppText>
        <Button onPress={() => router.replace('/signin')}>Log in again</Button>
        <Button onPress={() => router.replace(AppUtils.getHomeLink(loggedIn, isMainLogicalHost, communityMembership))}>Go Home</Button>
      </View>
      
      <Video
        source={"/videos/nsE-eV5pVXo.mp4"}
        ref={video}
        autoplay={false}
        height={170}
      />

      <Footer />
    </BasicScrollView>
  );
}
